import { AuthLogin } from 'shared/interfaces';
import { apiPostRequest } from 'utils/http/apiHttp';

export const apiAuth = {
  login: async (authLogin: AuthLogin) => {
    const resp = await apiPostRequest(`auth/login`, authLogin);

    if (resp.status !== 200) {
      throw new Error('Wrong login credentials. Please try again');
    }

    return resp?.json?.token;
  },
  logout: async () => {
    await apiPostRequest(`auth/logout`);
    return;
  },
  refresh: async () => {
    const respAuthRefresh = await apiPostRequest(`auth/refresh`, {
      application: process.env.REACT_APP_APPLICATION_ID,
    });
    if (!respAuthRefresh?.json?.token) {
      throw new Error(`Couldn't refresh user token`);
    }
    return respAuthRefresh?.json?.token;
  },
};
